import { render, staticRenderFns } from "./UiFooter.vue?vue&type=template&id=10cfc4c8&"
import script from "./UiFooter.vue?vue&type=script&lang=ts&"
export * from "./UiFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports